import { Snackbar } from '@mui/material'
import React, { createContext, useState } from 'react'

export const SeamlessSnackbarContext = createContext<
  React.Dispatch<React.SetStateAction<string>>
>(null as never)

type Props = {children: React.ReactNode}
export const SeamressSnackbarProvider: React.FC<Props> = ({children})=> {
  const [message, setMessage] = useState<string>('')
  return <SeamlessSnackbarContext value={setMessage}>
    {children}
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={3000}
      onClose={()=> setMessage('')}
      message={message}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
    />
  </SeamlessSnackbarContext>
}